module.exports = "dist/dc81817def276b4f21395f7ea5e88dcd.woff";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/fonts/roboto/Roboto-Bold.woff
// module id = 221
// module chunks = 0